import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GuardService } from '@shared/services/guard.service';

@Injectable()
export class AdminAuthGuard {
    constructor(
        private guardService: GuardService,
        private router: Router
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.guardService.isAdmin && window.innerWidth > 768 ? true : this.router.navigateByUrl('/');
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.guardService.isAdmin && window.innerWidth > 768 ? true : this.router.navigateByUrl('/');
    }
}
